export function clamp(value: number, min: number, max: number): number {
	return Math.max(min, Math.min(max, value));
}

const NEGATIVE_AMOUNT_PATTERN = /^\D*[-−]/;

export function isNegativeFormattedAmount(formattedAmount: string): boolean {
	return NEGATIVE_AMOUNT_PATTERN.test(formattedAmount);
}

const ZERO_AMOUNT_PATTERN = /^\D*0,(-|00)$/;

export function isZeroFormattedAmount(formattedAmount: string): boolean {
	return ZERO_AMOUNT_PATTERN.test(formattedAmount);
}
